class StickyAddBar {
  constructor(root) {
    this.root = root;
    this.toggleBtn = root.querySelector('[data-sab-toggle]');
    this.menu = root.querySelector('[data-sab-menu]');
    this.labelEl = root.querySelector('[data-sab-label]');
    this.priceEl = root.querySelector('[data-sab-price]');
    this.addBtn = root.querySelector('[data-sab-add]');
    this.addLabelEl = root.querySelector('[data-sab-add-label]');
    // 2026-09-23, Nachtrag (Christian: "STATT Preis im Button die %-Sparen-CTA-Kopie, wie der
    // echte Haupt-Button" -- ersetzt die vorherige Preis-im-Button-Anzeige): 2. Label-Span fuer
    // den vollen Desktop-Text ("Jetzt Set sichern - X% sparen"), siehe syncAddButton().
    this.addLabelDesktopEl = root.querySelector('[data-sab-add-label-desktop]');
    this.productNameEl = root.querySelector('[data-sab-product]');

    this.purchaseOptionsEl = document.querySelector('purchase-options');
    // 2026-09-23 (Christian, Flexplan-Portierung): bewusst NICHT mehr auf
    // 'purchase-options input[data-purchase-option]' gescoped (nur Radios INNERHALB des
    // <purchase-options>-Custom-Elements). Die Flexplan-Buybox (sections/main-product-starter-
    // kit-flexplan.liquid) rendert bei purchase_onetime_display: 'link' einen 3. Radio
    // ("Einzelkauf", .mpsk-onetime-link__radio) ABSICHTLICH AUSSERHALB von <purchase-options>
    // (siehe Kommentar in snippets/starter-kit-flexplan-part-buybuttons-3.liquid) -- trotzdem
    // Teil derselben name='purchase_option'-Radiogruppe und eine echte, auf der Seite sichtbare
    // Kaufoption. Seitenweite Suche nach [data-purchase-option] aendert fuer die alte Section
    // main-product-starter-kit.liquid NICHTS (dort liegen alle 3 Radios ohnehin ausschliesslich
    // innerhalb von <purchase-options>, siehe dortige Struktur), erfasst aber zusaetzlich diesen
    // Flexplan-Sonderfall korrekt.
    this.mainRadios = Array.from(document.querySelectorAll('input[data-purchase-option]'));
    this.mainSubmitBtn = document.querySelector('[data-bundle-submit]');
    this.observeTarget =
      document.querySelector('.purchase-options__wrapper') || document.querySelector('.product-form');

    if (!this.mainRadios.length || !this.mainSubmitBtn || !this.observeTarget) {
      // Kein purchase-options-Setup auf dieser Seite -- Sticky-Bar entfernen statt leer anzuzeigen.
      root.remove();
      return;
    }

    this.renderProductName();
    this.buildMenu();
    this.bindEvents();
    this.syncFromMain();
    this.setupVisibilityObserver();
  }

  // 2026-09-23 (Christian, Flexplan-Portierung): getTitleEl() kapselt die Titel-Suche mit
  // Fallback-Selektoren, weil die neuere Flexplan-Buybox (sections/main-product-starter-kit-
  // flexplan.liquid, IM8-Karten-Redesign "Meisterloesung") KEIN '.purchase-options__header
  // strong' mehr nutzt, sondern '.pcard-title' (30T-/90T-Karten) bzw. '.mpsk-onetime-link__text'
  // (kompakter "Einmalig kaufen"-Link). Alte Section main-product-starter-kit.liquid nutzt
  // weiterhin ausschliesslich '.purchase-options__header strong' -- das bleibt hier bewusst der
  // ERSTE, unveraenderte Versuch, damit ihr Verhalten 1:1 identisch bleibt (kein Fallback wird
  // dort je erreicht). Preis-Selektor '.purchase-options__price' braucht KEINEN Fallback: dieses
  // Klassenattribut liegt in beiden Sections (alt UND Flexplan-pcard/mpsk-onetime-link) exakt auf
  // demselben Element, nur mit zusaetzlichen eigenen Klassen daneben.
  getTitleEl(label) {
    return (
      label.querySelector('.purchase-options__header strong') ||
      label.querySelector('.pcard-title') ||
      label.querySelector('.mpsk-onetime-link__text')
    );
  }

  // 2026-09-23 (Christian: "Auswahlmoeglichkeiten ... exakt so wie bei im8 health bitte" --
  // Format "{Laufzeit}-Tage-Vorrat (Spare {X}%) {Y},{YY}€ pro Tag"): getSavingsPercent() und
  // getPerDayText() LESEN NUR die bereits vorhandenen, server-/JS-berechneten Werte aus dem DOM
  // (.pcard-badge / .pcard-price-perday, siehe snippets/starter-kit-flexplan-part-buybuttons-
  // 1.liquid und -2.liquid: sub_price_diff_pct/additional_price_diff_pct fuer den Badge,
  // sub_per_day_cents/add_per_day_cents fuer den Tagespreis) -- KEINE neue Berechnung, exakt das
  // bestehende Architekturprinzip dieser Datei (siehe Kommentar oben "Enthaelt bewusst KEINE
  // eigene Preis-/Verfuegbarkeits-Logik"). Beide Karten (30T/90T) zeigen den kombinierten
  // "Heute im Warenkorb"-Rabatt bzw. den Pad-Tagespreis bereits 1:1 fertig formatiert -- hier wird
  // nur noch die Zahl per Regex herausgezogen (Badge) bzw. die Endung "/Tag" durch " pro Tag"
  // ersetzt (reine Wording-Anpassung fuer die Sticky-Bar, keine Preislogik). Alte Section
  // main-product-starter-kit.liquid hat weder .pcard-badge noch .pcard-price-perday (dort sind
  // die 3 Optionen "Abonnieren & Sparen"/"Sparset Einzelkauf"/"Einzelkauf" KEINE Laufzeit-Wahl im
  // Sinne von 30T/90T, siehe purchase_subscription_duration_days-Setting existiert dort gar
  // nicht) -- getSavingsPercent()/getPerDayText() liefern dort planmaessig null, buildDisplayParts()
  // faellt dann auf das alte, unveraenderte Titel+Preis-Verhalten zurueck (kein Combo-Format).
  getSavingsPercent(label) {
    const badgeEl = label.querySelector('.pcard-badge');
    if (!badgeEl) return null;
    const match = badgeEl.textContent.match(/(\d+)/);
    return match ? match[1] : null;
  }

  getPerDayText(label) {
    const perDayEl = label.querySelector('.pcard-price-perday');
    if (!perDayEl) return null;
    const raw = perDayEl.textContent.replace(/\s+/g, ' ').trim();
    if (!raw) return null;
    // ".pcard-price-perday" rendert z.B. "€0,60/Tag" (Theme-Konvention: Waehrungssymbol VOR der
    // Zahl, siehe money-Filter-Output ueberall sonst im Shop) -- Christian moechte in der Sticky-
    // Bar ausgeschrieben "pro Tag" statt der Kompakt-Abkuerzung "/Tag" von der Haupt-Karte.
    return raw.replace(/\/\s*Tag\s*$/i, ' pro Tag');
  }

  // 2026-09-23: baut Label-/Preis-HTML fuer EINE Option (Dropdown-Eintrag oder Toggle-Anzeige)
  // -- kombiniertes IM8-Format wenn Badge+Tagespreis vorhanden (Flexplan 30T-/90T-Karten), sonst
  // 1:1 der alte Titel+Preis-Fallback (alte Section, Flexplan-Einzelkauf-Link).
  buildDisplayParts(label, titleEl, priceEl) {
    const pct = this.getSavingsPercent(label);
    const perDay = this.getPerDayText(label);

    if (pct && perDay) {
      return {
        labelHTML:
          (titleEl ? titleEl.innerHTML : '') +
          ' <span class="sab-dropdown__savings">(Spare ' + pct + '%)</span>',
        priceHTML: perDay,
      };
    }

    return {
      labelHTML: titleEl ? titleEl.innerHTML : '',
      priceHTML: priceEl ? priceEl.innerHTML : '',
    };
  }

  // 2026-09-23, Nachtrag (Christian: "STATT Preis im Button die %-Sparen-CTA-Kopie, wie der echte
  // Haupt-Button" -- ersetzt die vorherige Preis-im-Button-Anzeige): liefert den reinen,
  // sichtbaren Text des ECHTEN Haupt-Buttons ([data-bundle-submit]). Einzige Quelle fuer die
  // Button-Beschriftung der Sticky-Bar -- KEINE eigene %-Berechnung (Architekturprinzip). Auf der
  // Flexplan-Buybox liefert das z.B. "Jetzt Set sichern - 29% sparen" (live berechnet in
  // updateSelectedVariantAvailability(), assets/product-form-starter-kit-flexplan.js, inkl. des
  // 22.09.-Bugfixes fuer den laufzeit-spezifischen Vergleichspreis -- identisch zum
  // .pcard-badge-Wert). Auf der alten Section main-product-starter-kit.liquid liefert das
  // "In den Warenkorb – €29,99" (product-form-starter-kit.js, langer window.variantStrings.
  // quickAdd-Text + Preis).
  getMainButtonText() {
    return (this.mainSubmitBtn.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // Schneidet EXAKT das Suffix ab, das product-form-starter-kit-flexplan.js an den Haupt-Button
  // anhaengt (" - ${percentSaved}% sparen" bzw. englisch " - ${percentSaved}% off", siehe
  // Kommentar dort "CTA-Text von ... auf 'Jetzt Set sichern - X% sparen' umgestellt"). Gibt null
  // zurueck, wenn kein Treffer (z.B. percentSaved=0 -> kein Suffix vorhanden, oder alte Section).
  stripPercentSuffix(fullText) {
    const match = fullText.match(/^(.*?)\s*-\s*\d+%\s*(?:sparen|off)\s*$/i);
    return match ? match[1].trim() : null;
  }

  // 2026-09-23: baut den gekuerzten Mobile-CTA-Text aus dem geharvesteten Haupt-Button-Text.
  // Fall 1 (Flexplan, mit "- X% sparen"-Suffix): Suffix abschneiden -> "Jetzt Set sichern".
  // Fall 2 (Flexplan, percentSaved=0, kein Suffix): Text ist bereits kurz genug ("Jetzt Set
  // sichern") -> unveraendert uebernehmen.
  // Fall 3 (alte Section main-product-starter-kit.liquid): deren Haupt-Button-Text enthaelt IMMER
  // ein En-Dash "–" (U+2013, siehe product-form-starter-kit.js: `${baseText} – <span>${preis}
  // </span>`) VOR dem angehaengten Preis -- fuer die schmale Mobile-Pille zu lang (derselbe Grund,
  // aus dem diese Datei urspruenglich window.variantStrings.quickAdd mied, siehe getTitleEl()-
  // Kommentar weiter oben). En-Dash im Text ist ein zuverlaessiges, bereits im Code vorhandenes
  // Unterscheidungsmerkmal (Flexplan nutzt durchgehend den normalen Bindestrich "-") -- kein
  // willkuerlicher Laengen-Schwellwert noetig. In diesem Fall bleibt der alte, kurze, hart
  // codierte Fallback-Text bestehen (Sold-out-Text der alten Section hat KEIN En-Dash und faellt
  // deshalb bereits in Fall 2 durch, siehe Bericht).
  getMobileCtaText(fullText) {
    if (fullText.indexOf('–') !== -1) {
      return 'Hinzufügen';
    }
    return this.stripPercentSuffix(fullText) || fullText;
  }

  // 2026-09-23 (Christian: "Auf desktop den space nutzen noch mit dem Set Namen"): Quelle ist
  // das bereits vorhandene .product__title-H1 (identisch in main-product-starter-kit.liquid UND
  // main-product-starter-kit-flexplan.liquid vorhanden, kein neuer Server-Code noetig). Fallback
  // auf document.title (vor einem "|"/"–"-Trenner), falls das H1 aus irgendeinem Grund fehlt.
  // Bewusst KEIN Produktbild (Christians bestehende Entscheidung bleibt gueltig, siehe
  // claude/sticky-add-cta-im8-style-sept2026.md) -- nur Text.
  getProductName() {
    const h1 = document.querySelector('.product__title');
    if (h1 && h1.textContent.trim()) return h1.textContent.trim();
    const docTitle = (document.title || '').trim();
    if (!docTitle) return '';
    return docTitle.split(/[–|]/)[0].trim();
  }

  renderProductName() {
    if (!this.productNameEl) return;
    const name = this.getProductName();
    if (name) this.productNameEl.textContent = name;
  }

  buildMenu() {
    this.menu.innerHTML = '';
    this.mainRadios.forEach((radio) => {
      // 2026-09-23, Nachtrag (Christian: "Einzelkauf-Option aus dem Sticky-Bar-DROPDOWN entfernen,
      // nur noch die 2 Flexplan-Laufzeit-Optionen (30T/90T)"): radio.value === 'onetime' ist der
      // "Einzelkauf"/"Einmalig kaufen"-Radio (siehe snippets/starter-kit-flexplan-part-buybuttons-
      // 3.liquid: `value='onetime'` auf dem .mpsk-onetime-link__radio; identisch in der alten
      // Section main-product-starter-kit.liquid). Bewusst per value gefiltert (robust, uebersetz-
      // ungsunabhaengig) statt per Titel-Text. NUR diese Menu-Liste wird gefiltert -- der echte
      // Radio/Link auf der Haupt-Buying-Box (this.mainRadios, syncFromMain()) bleibt unangetastet,
      // falls er dort z.B. bereits ausgewaehlt ist. 'onetime-additional' ist NICHT gemeint (das
      // ist die 90-Tage-Vorrat-Karte, keine Einzelkauf-Option) und bleibt im Dropdown.
      if (radio.value === 'onetime') return;
      const label = document.querySelector(`label[for="${radio.id}"]`);
      if (!label) return;
      const titleEl = this.getTitleEl(label);
      const priceEl = label.querySelector('.purchase-options__price');
      if (!titleEl || !priceEl) return;

      const parts = this.buildDisplayParts(label, titleEl, priceEl);

      const option = document.createElement('button');
      option.type = 'button';
      option.className = 'sab-dropdown__option';
      option.setAttribute('role', 'option');
      option.dataset.sabTargetId = radio.id;
      option.innerHTML =
        '<span class="sab-dropdown__option-label">' +
        parts.labelHTML +
        '</span><span class="sab-dropdown__option-price">' +
        parts.priceHTML +
        '</span>';
      option.addEventListener('click', () => {
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.closeMenu();
      });
      this.menu.appendChild(option);
    });
  }

  syncFromMain() {
    const checkedRadio = this.mainRadios.find((r) => r.checked);
    if (checkedRadio) {
      const label = document.querySelector(`label[for="${checkedRadio.id}"]`);
      if (label) {
        const titleEl = this.getTitleEl(label);
        const priceEl = label.querySelector('.purchase-options__price');
        const parts = this.buildDisplayParts(label, titleEl, priceEl);
        this.labelEl.innerHTML = parts.labelHTML;
        this.priceEl.innerHTML = parts.priceHTML;
      }

      Array.from(this.menu.children).forEach((opt) => {
        opt.classList.toggle('is-selected', opt.dataset.sabTargetId === checkedRadio.id);
      });
    }

    this.syncAddButton();
  }

  syncAddButton() {
    const disabled = !!this.mainSubmitBtn.disabled;
    const isLoading = this.mainSubmitBtn.classList.contains('is-loading');

    this.addBtn.disabled = disabled;
    this.addBtn.classList.toggle('is-disabled', disabled);
    this.addBtn.classList.toggle('is-loading', isLoading);

    // 2026-09-23, Nachtrag (Christian: "STATT Preis im Button die %-Sparen-CTA-Kopie, wie der
    // echte Haupt-Button -- KEINE eigene %-Berechnung in der Sticky-Bar bauen"): Label wird jetzt
    // 1:1 vom echten Haupt-Button abgeleitet (getMainButtonText()), NICHT mehr hart codiert.
    // Fallback 'Hinzufügen' nur fuer den (praktisch nie eintretenden) Fall, dass der Haupt-Button
    // noch komplett leer ist (z.B. bevor product-form-starter-kit(-flexplan).js seinen ersten
    // init()-Durchlauf abgeschlossen hat).
    const fullText = this.getMainButtonText() || 'Hinzufügen';
    this.addLabelEl.textContent = this.getMobileCtaText(fullText);
    if (this.addLabelDesktopEl) this.addLabelDesktopEl.textContent = fullText;
  }

  bindEvents() {
    this.toggleBtn.addEventListener('click', () => this.toggleMenu());

    document.addEventListener('click', (e) => {
      if (!this.root.contains(e.target)) this.closeMenu();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeMenu();
    });

    // 2026-09-23 (Christian, Flexplan-Portierung): auf 'document' statt auf this.purchaseOptionsEl
    // horchen (mit Filter auf [data-purchase-option] als Ziel), weil der Flexplan-'Einzelkauf'-
    // Radio (siehe mainRadios-Kommentar oben) AUSSERHALB von <purchase-options> liegt -- sein
    // 'change'-Event wuerde dort nie ankommen (kein Bubbling durch einen Nicht-Vorfahren). Fuer
    // die alte Section main-product-starter-kit.liquid (alle Radios liegen innerhalb von
    // <purchase-options>) liefert die document-weite Delegation exakt dasselbe Ergebnis wie
    // vorher -- change-Events auf diesen Radios bubblen ohnehin bis zum document hoch.
    document.addEventListener('change', (e) => {
      if (e.target && e.target.matches && e.target.matches('[data-purchase-option]')) {
        this.syncFromMain();
      }
    });

    this.addBtn.addEventListener('click', () => {
      if (this.mainSubmitBtn && !this.mainSubmitBtn.disabled) {
        this.mainSubmitBtn.click();
      }
    });

    // Farb-/Groessenwechsel (color-btn) aktualisiert im Haupt-JS nur die Preisanzeige der
    // gerade aktiven Option, feuert aber kein 'change' auf purchase-options -- Menu nach kurzer
    // Verzoegerung (nach dem Haupt-Click-Handler) neu aufbauen, um wenigstens den gleichen Stand
    // wie die Haupt-Buying-Box zu spiegeln.
    document.querySelectorAll('.color-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        setTimeout(() => {
          this.buildMenu();
          this.syncFromMain();
        }, 50);
      });
    });

    // Ladezustand/Verfuegbarkeit des Haupt-Buttons (z.B. waehrend addProductsToCart()) spiegeln.
    // 2026-09-23, Nachtrag (Christian, CTA-Text statt Preis im Button): Observer um childList/
    // characterData/subtree ERWEITERT (vorher nur attributes) -- die Sticky-Bar uebernimmt jetzt
    // den TEXT-INHALT des Haupt-Buttons (z.B. "Jetzt Set sichern - 29% sparen" aus
    // updateSelectedVariantAvailability() in product-form-starter-kit-flexplan.js), nicht nur
    // dessen disabled/class-Attribute. Der Haupt-Button setzt seinen Text per
    // submitBtn.innerHTML/textContent = ... (Kind-Textknoten-Aenderung, KEINE Attribut-Aenderung)
    // -- ohne diese Erweiterung wuerde die Sticky-Bar einen Farb-/Plan-Wechsel (der den %-Wert
    // aendert) nicht mitbekommen.
    const observer = new MutationObserver(() => this.syncAddButton());
    observer.observe(this.mainSubmitBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'class'],
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  toggleMenu() {
    if (this.menu.hidden) this.openMenu();
    else this.closeMenu();
  }

  openMenu() {
    this.menu.hidden = false;
    this.toggleBtn.setAttribute('aria-expanded', 'true');
  }

  closeMenu() {
    this.menu.hidden = true;
    this.toggleBtn.setAttribute('aria-expanded', 'false');
  }

  setupVisibilityObserver() {
    if (!('IntersectionObserver' in window)) {
      this.root.hidden = false;
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.root.hidden = entry.isIntersecting;
          if (entry.isIntersecting) this.closeMenu();
        });
      },
      { threshold: 0 }
    );
    observer.observe(this.observeTarget);
  }
}

// Manche Produkt-Templates (nicht dieses Snippet, sondern individuell pro Template als
// custom_liquid-Block eingebettet, z.B. templates/product.starter-kit-3.json o.ae.) tragen noch
// eine aeltere, unabhaengige Sticky-CTA-Bar (Klasse "ig-sticky-pdp-cta", ohne Laufzeit-Dropdown).
// Ueberall dort, wo DIESES neue Snippet gerendert wird, ersetzt es die alte Bar vollstaendig --
// die alte Bar wird deshalb entfernt, statt beide parallel anzuzeigen.
document.querySelectorAll('.ig-sticky-pdp-cta').forEach((el) => el.remove());

// Dieses Script ist defer-geladen -- DOM ist beim Ausfuehren bereits vollstaendig geparst,
// inkl. der bereits hochgestuften <purchase-options>-Custom-Element-Initialisierung aus
// product-form-starter-kit.js (das Script davor im Dokument, ebenfalls defer -- garantierte
// Ausfuehrungsreihenfolge). Kein DOMContentLoaded-Listener noetig (wuerde sonst evtl. doppelt
// initialisieren, siehe Lektion aus vorheriger Session).
document.querySelectorAll('[data-sab-bar]').forEach((el) => new StickyAddBar(el));
